import { render } from "./CustomNewsCard.vue?vue&type=template&id=8a1460e4&scoped=true"
import script from "./CustomNewsCard.vue?vue&type=script&lang=js"
export * from "./CustomNewsCard.vue?vue&type=script&lang=js"

import "./CustomNewsCard.vue?vue&type=style&index=0&id=8a1460e4&scoped=true&lang=css"
import "./CustomNewsCard.vue?vue&type=style&index=1&id=8a1460e4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1460e4"]])

export default __exports__